import { useEffect, useState } from "react";
import { getReferralSummary } from "../services/engagementService";

// The signed-in filer's referral code, for share links (null until loaded, or if the
// summary can't be fetched - the share box then simply shares without a code).
export function useReferralCode(enabled = true) {
  const [code, setCode] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    getReferralSummary()
      .then((s) => {
        if (active) setCode(s?.code || null);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [enabled]);
  return code;
}
